import Clock from './_clock.js'
import FlexPane from './_flex-pane.js'
import SearchControllerView from './_search-controller-view.js'
import ConfigurableMargin from './_configurable-margin.js'
import ConfigurablePane from './_configurable-pane.js'
import SelectableButtonGroup from './_selectable-button-group.js'
import SessionTime from './_session-time.js'
import Button from './_button.js'
import Image from './_image.js'
import Intent from './_intent.js'
import SettingsMenuPopup from './_settings-menu-popup.js'
import Text from './_text.js'

export default {
  name: 'MainNavigationBar',
  values: {
    isCurrentTimeVisible: false,
    currentTime: {
      configSet: Clock,
      configValues: {
        container: {
          style: {
            padding: '0px 8px',
            alignItems: 'center',
            flexDirection: 'column',
            justifyContent: 'center',
          },
        },
      },
    },
    timeBlocksContainer: {
      configSet: FlexPane,
      configValues: {
        style: {
          flexGrow: 0,
          flexShrink: 1,
          justifyContent: 'flex-end',
        },
        separator: {
          style: {
            size: '1px',
            margin: '8px 0px',
          },
        },
      },
    },
    searchControllerView: {
      configSet: SearchControllerView,
      configValues: {
        searchView: {
          searchInput: {
            container: {
              base: {
                style: {
                  minHeight: '32px',
                  maxHeight: '32px',
                },
              },
              active: {
                style: {
                  minWidth: '248px',
                },
              },
              inactive: {
                style: {
                  maxWidth: '160px',
                },
              },
            },
            style: {
              wrapperContainer: {
                margin: '8px',
              },
            },
          },
        },
      },
    },
    searchPosition: 'right',
    style: {
      rootContainer: {
        $mixin: [
          {
            configSet: ConfigurableMargin,
          },
          {
            configSet: ConfigurablePane,
          },
        ],
      },
      innerContainer: {
        maxWidth: '100%',
        _desktop_maxWidth: '1440px',
      },
    },
    buttonPosition: 'left',
    rightContainer: {
      configSet: FlexPane,
      configValues: {
        style: {
          justifyContent: 'flex-end',
        },
      },
    },
    linkButtons: {
      configSet: SelectableButtonGroup,
      configValues: {
        container: {
          itemSpacing: '8px',
          style: {
            justifyContent: 'flex-start',
            padding: '0 0 0 8px',
          },
        },
        selectableButton: {
          unselected: {
            style: {
              base: {
                flexGrow: 0,
                flexBasis: '128px',
                alignItems: 'center',
                flexDirection: 'column',
              },
            },
          },
          selected: {
            style: {
              base: {
                flexGrow: 0,
                flexBasis: '128px',
                alignItems: 'center',
                flexDirection: 'column',
              },
            },
          },
        },
      },
    },
    sessionTime: {
      configSet: SessionTime,
      configValues: {},
    },
    showHelpButton: true,
    _mobile_showHelpButton: false,
    showSettingsButton: true,
    _mobile_showSettingsButton: false,
    showSessionTime: false,
    _mobile_showSessionTime: false,
    helpButton: {
      configSet: Button,
      configValues: {
        style: {
          base: {
            flexGrow: 0,
            flexBasis: '40px',
            padding: '12px 0',
          },
        },
      },
    },
    helpIcon: {
      configSet: Image,
      configValues: {
        src: 'help',
        style: {
          flexGrow: 1,
          flexBasis: '16px',
        },
      },
    },
    helpIntent: {
      configSet: Intent,
      configValues: {},
    },
    settingsMenu: {
      configSet: SettingsMenuPopup,
      configValues: {},
    },
    linkText: {
      configSet: Text,
      configValues: {
        style: {
          textAlign: 'center',
        },
      },
    },
    linkTextContainer: {
      configSet: FlexPane,
      configValues: {
        style: {
          flexBasis: '40px',
          alignItems: 'center',
        },
      },
    },
    items: undefined,
  },
  meta: {
    extendable: false,
  },
}
